import React, { useContext } from "react";
import Context from "../../Context";

export default function DefaultNotFound(props) {
  const cx = useContext(Context);
  return (
    <div
      className="alert alert-custom alert-white alert-shadow fade show gutter-b"
      role="alert"
    >
      <div className="alert-icon">
        <i className="flaticon2-information text-dark-25"></i>
      </div>
      <div className="alert-text">
        {props.message || cx.t("common.notfound")}
      </div>
    </div>
  );
}
